import { ChevronRightRounded } from '@mui/icons-material'
import { ReactNode } from 'react'
import { Button } from 'ui'

import style from './InformationCard.module.scss'

export type InformationCardProps = {
  title: string
  subtitle: string
  link: string
  Icon: ReactNode
  linkText: string
}

// блок с информацией о странице
export function InformationCard({
  title,
  subtitle,
  link,
  Icon,
  linkText,
}: InformationCardProps) {
  return (
    <div className={style.informationCardContainer}>
      <span className='h1'>Личный кабинет покупателя</span>
      <div className={style.informationCard}>
        <div className={style.informationCardHeader}>
          <span className='h2'>{title}</span>
          <span className='default-text'>{subtitle}</span>
        </div>

        <div className={style.informationCardIcon}>{Icon}</div>

        <Button
          // @ts-ignore
          to={link}
          variant='contained'
          endIcon={<ChevronRightRounded />}
          className={style.informationCardButton}
          data-testid='information-card-link'
        >
          {linkText}
        </Button>
      </div>
    </div>
  )
}
